import type { PositionBasePreset } from "@/shared/state/visualization/schema/v1/three-d";

import { presets, type PositionPreset } from "./PositionConfig/presets";

/**
 * The conventions a vector field's axes can be bound in: the position presets
 * whose axes are Cartesian, ROS first, so a velocity or force lands in the
 * scene the way a position in the same frame does. Lat/Lon/Alt is left out: a
 * vector has no geodetic form.
 */
export const VECTOR_FIELD_PRESETS: readonly PositionPreset[] = [
  presets.forward_left_up,
  presets.east_north_up,
  presets.north_east_down,
  presets.forward_right_up,
];

/**
 * What each slot holds, named by the picked convention — a forward/left/up
 * vector binds its left axis into the right slot — or by the slot itself when
 * no convention was picked.
 */
export function vectorFieldAxisLabels(
  basePreset: PositionBasePreset | undefined,
): PositionPreset["labels"] {
  return basePreset
    ? presets[basePreset].labels
    : { forward: "Forward", right: "Right", up: "Up" };
}
